import baseOverrides from './../baseOverrides'

export default `
  ${baseOverrides}
  .sf-container > :not(nav) {
      transform: none;
      will-change: initial;
  }
`
